import { Head } from '@inertiajs/react'

import { AppShell } from '@/layouts/AppShell'
import { PageHeader } from '@/components/layout/PageHeader'
import type { Breadcrumb } from '@/types/shared'
import { Form } from './components/Form'

type PrefectureOption = {
  code: number
  name: string
}

type AdminTeamEditProps = {
  team: {
    id: string
    name: string | null
    prefectureId: number | null
  }
  options: {
    prefectures: PrefectureOption[]
  }
  breadcrumbs: Breadcrumb[]
}

export default function Edit({ team, options, breadcrumbs }: AdminTeamEditProps) {
  return (
    <AppShell>
      <Head title={`チーム編集｜${team.name ?? '未設定'}`} />
      <PageHeader
        title="チーム編集"
        description="既存のチーム情報を更新します。"
        breadcrumbs={breadcrumbs}
      />
      <Form values={team} prefectures={options.prefectures} mode="edit" />
    </AppShell>
  )
}
